<div class="table-cell">
  <ng-container *ngIf="unidentified; else showContent">
    <div data-testid="unidentified-cell" class="phx-web-type-default phx-web-color-content-negative">
      {{ unidentifiedText }}
    </div>
  </ng-container>

  <ng-template #showContent>
    <!-- PRIMARY line -->
    <ng-container *ngIf="primaryConfig.entity; else textPrimary">
      <cross-link
        class="d-inline-block phx-web-type-default ellipsis w-100"
        [entity]="primaryConfig.entity"
        [type]="primaryConfig.type"
        [routeParams]="primaryConfig.routeParams ? primaryConfig.routeParams : {}"
        [params]="primaryConfig.params"
        [deactivated]="primaryConfig.deactivated"
        [target]="primaryConfig.target"
        [noGroupsCheck]="primaryConfig.noGroupsCheck"
        [featureType]="primaryConfig.featureType"
        phx-tooltip
        [phxContent]="primaryConfig.entity.name || primaryConfig.entity.number"
        tooltipOnTruncate
        (click)="$event.stopPropagation()"
      ></cross-link>
    </ng-container>
    <ng-template #textPrimary>
      <div
        data-testid="entity-table-cell"
        class="d-inline-block ellipsis phx-web-type-default phx-web-color-content"
        [class.primary-multiline]="primaryConfig.multiline"
        [style.-webkit-line-clamp]="primaryConfig.multiline?.maxLines"
        phx-tooltip
        [phxContent]="primaryConfig.text"
        tooltipOnTruncate
      >
        <ng-container *ngIf="!!primaryConfig.text else emptyState">
          <span>{{ primaryConfig.text }}</span>
        </ng-container>
      </div>
    </ng-template>

    <!-- SECONDARY + TERTIARY on one line -->
    <ng-container *ngIf="hasSecondaryRow">
      <div
        data-testid="entity-table-cell"
        class="d-inline-block ellipsis phx-web-type-small phx-web-color-content-subdued"
        phx-tooltip
        [phxContent]="secondaryTooltip"
        tooltipOnTruncate
      >
        <span *ngIf="secondary">{{ secondary }}</span>
        <ng-container *ngIf="!secondary && (hasPrimaryText || tertiary)" [ngTemplateOutlet]="emptyState"></ng-container>
        <span *ngIf="(!!secondary || !!tertiary) && tertiary !== undefined" class="separator"></span>
        <span *ngIf="tertiary">{{ tertiary }}</span>
        <ng-container *ngIf="secondary && !tertiary && tertiary !== undefined" [ngTemplateOutlet]="emptyState"></ng-container>
      </div>
    </ng-container>

    <ng-template #emptyState>
      <span class="phx-web-color-content-inactive">{{ placeholder }}</span>
    </ng-template>
  </ng-template>
</div>
